'use client';

import Link from 'next/link';
import { Anchor, Container, Paper, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { getCarComparisonLinkProps } from '../../../lib/content/comparisonLinks';
import type { PageWidgetItem } from '../../../types/content';
import {
  getWidgetCardStyle,
  widgetLinkStyle,
  widgetSectionPadding,
  widgetSubtitleStyle,
  widgetTitleStyle,
} from './widgetStyles';

export function ContactCardsWidget({
  title,
  subtitle,
  items,
  mapHref,
}: {
  title?: string;
  subtitle?: string;
  items: PageWidgetItem[];
  mapHref: (href?: string) => string | undefined;
}) {
  if (!items.length) return null;

  return (
    <Container size="xl" py={widgetSectionPadding}>
      <Stack gap={12}>
        {title ? <Title order={2} style={widgetTitleStyle}>{title}</Title> : null}
        {subtitle ? <Text style={{ ...widgetSubtitleStyle, maxWidth: 740 }}>{subtitle}</Text> : null}

        <SimpleGrid cols={{ base: 1, md: 3 }} spacing={16}>
          {items.map((item, index) => {
            const href = mapHref(item.href);
            return (
              <Paper key={`${item.title || 'contact'}-${index}`} p={20} radius={30} withBorder style={getWidgetCardStyle(index)}>
                <Stack gap={6}>
                  <Text fw={600} style={{ color: 'var(--text-primary)' }}>{item.title || item.label || `Card ${index + 1}`}</Text>
                  {item.body ? <Text size="sm" style={{ ...widgetSubtitleStyle, maxWidth: 'unset' }}>{item.body}</Text> : null}
                  {href ? (
                    <Anchor
                      component={Link}
                      href={href}
                      {...getCarComparisonLinkProps(href)}
                      underline="never"
                      style={widgetLinkStyle}
                    >
                      {item.href?.startsWith('mailto:') || item.href?.startsWith('tel:') ? 'Avaa' : 'Siirry'}
                    </Anchor>
                  ) : null}
                </Stack>
              </Paper>
            );
          })}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
